import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api';

/**
 * Owner-only: delete a group. Cascades members, invites, and anything else
 * server-side. Invalidates `['groups','my']` plus any group-scoped caches.
 */
export function useDeleteGroup() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (groupId: string) =>
      api.delete<{ ok: true }>(`/api/groups/${groupId}`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['groups', 'my'] });
      void qc.invalidateQueries({ queryKey: ['standings'] });
      void qc.invalidateQueries({ queryKey: ['predictions'] });
    },
  });
}
